module.exports = __webpack_public_path__ + "on_ramp_slight_right.svg?d3cd2e26f64d869a6cc79c801bb4750b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/on_ramp_slight_right.svg
// module id = 205
// module chunks = 0